<div class="sliding-tour-panel" *ngIf="!isPermanentlyHidden">


  <button class="tour-tab-button" (click)="togglePanel()" [class.active]="isPanelOpen"
    [title]="isPanelOpen ? 'Close Tour Panel' : 'Open Tour Panel'">

    <div class="tab-content">
      <lucide-icon [name]="tourIcon" class="tab-icon"></lucide-icon>
      <span class="tab-text">Tour</span>
    </div>

    <div class="tab-arrow">
      <lucide-icon [name]="isPanelOpen ? 'chevron-right' : 'chevron-left'" class="arrow-icon">
      </lucide-icon>
    </div>
  </button>


  <div class="tour-panel" [class.open]="isPanelOpen">


    <div class="panel-header">
      <div class="header-content">
        <lucide-icon [name]="tourIcon" class="header-icon"></lucide-icon>
        <h3 class="panel-title">{{ tourTitle }}</h3>
      </div>

      <div class="header-actions">
        <button class="close-button" (click)="togglePanel()" title="Close panel">
          <lucide-icon name="x" class="close-icon"></lucide-icon>
        </button>

        <button class="hide-permanently-button" (click)="hidePanelPermanently()" title="Hide panel permanently">
          <lucide-icon name="eye-off" class="hide-icon"></lucide-icon>
        </button>
      </div>
    </div>


    <div class="panel-content">


      <div class="tour-actions">
        <button class="start-tour-button" (click)="startTour()" title="Start the tour">
          <lucide-icon name="play" class="action-icon"></lucide-icon>
          <span>Start Tour</span>
        </button>


        <button *ngIf="showResetOption && hasSeenTour()" class="reset-tour-button" (click)="resetTourSetting()"
          title="Show tour again on next visit">
          <lucide-icon name="refresh-cw" class="action-icon"></lucide-icon>
          <span>Reset</span>
        </button>
      </div>


      <div class="tour-info">
        <p class="info-text">Learn about key features and navigation</p>
      </div>
    </div>
  </div>
</div>
